import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { AssessmentsService, type AssessmentVariantMetadata, type AssessmentVariantMetadataCreate, type AssessmentVariantMetadataUpdate } from "@/lib/api_client";
import { getAuthHeaders } from "@/lib/api";
import { fetchAll } from "./fetchAll";

export const useAssessmentVariantMetadataList = () =>
  useQuery({
    queryKey: ["assessment-variant-metadata"],
    queryFn: () => fetchAll<AssessmentVariantMetadata>(AssessmentsService.getApiAssessmentVariantMetadata),
    staleTime: 5 * 60_000,
  });

export const useCreateAssessmentVariantMetadata = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: AssessmentVariantMetadataCreate) => {
      const res = await AssessmentsService.postApiAssessmentVariantMetadata({ body: data, headers: getAuthHeaders() });
      if (!res.data) throw new Error("Failed");
      return res.data as unknown as AssessmentVariantMetadata;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["assessment-variant-metadata"] }),
  });
};

export const useUpdateAssessmentVariantMetadata = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: AssessmentVariantMetadataUpdate }) => {
      const res = await AssessmentsService.putApiAssessmentVariantMetadataById({ path: { id }, body: data, headers: getAuthHeaders() });
      if (!res.data) throw new Error("Failed");
      return res.data as unknown as AssessmentVariantMetadata;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["assessment-variant-metadata"] }),
  });
};
